<template>
  <div
    v-for="(akasatana, index) in akasatanas"
    :key="index"
  >
    <div
      v-if="common.tieUp && common.tieUp.some(content => content.akasatana === akasatana)"
      class="w-full"
    >
      <div
        class="bg-top bg-no-repeat bg-cover bg-fixed text-left content-base whitespace-pre-wrap break-all"
        style="color: rgb(168, 168, 168); margin: 20px 18px 0px; padding: 0px; font-weight: 700;"
      >
        ■{{ akasatana }}
      </div>
    </div>

    <div
      v-for="content in common.tieUp"
      :key="content.id"
      :content="content"
    >
      <template
        v-if="akasatana===content.akasatana"
      >
        <div class="w-full">
          <div class="bg-top bg-no-repeat bg-cover bg-fixed content-base" style="border-bottom: 4px dotted rgb(216, 216, 216); margin: 10px 18px 0px; padding: 0px 0px 7px;">
            <div class="flex flex-wrap w-full items-center">
              <div style="width: calc(70%);">
                <div class="w-full">
                  <div class="bg-top bg-no-repeat bg-cover bg-fixed content-base" style="margin: 0px; padding: 0px;">
                    <div class="bg-top bg-no-repeat bg-cover bg-fixed" style="margin: 0px; padding: 0px;">
                      <div class="flex flex-wrap justify-around w-full">
                        <div class="w-full">
                          <div
                            class="bg-top bg-no-repeat bg-cover bg-fixed text-left content-base"
                            style="font-size: 12pt; margin: 0px; padding: 0px; font-weight: 500;"
                          >
                            <span class="content-text-content"><p>{{ content.store }}</p></span>
                          </div>
                        </div>
                        <div class="w-full">
                          <div
                            class="bg-top bg-no-repeat bg-cover bg-fixed text-left content-base"
                            style="font-size: 8pt; margin: 0px; padding: 0px;"
                          >
                            <span class="content-text-content"><p>応募期間： {{ dayjs.tz(content.begin, 'Asia/Tokyo').format('YYYY年MM月DD日') }} ～ {{ dayjs.tz(content.end, 'Asia/Tokyo').subtract(1, 'second').format('YYYY年MM月DD日') }}</p></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: calc(30%);">
                <div class="w-full">
                  <div class="bg-top bg-no-repeat bg-cover bg-fixed content-base flex flex-col items-stretch text-center" style="margin: 0px; padding: 0px;">
                    <div
                      v-if="content.enable"
                      class="bg-top bg-no-repeat bg-cover bg-fixed w-full select-none cursor-pointer content-button"
                      style="color: rgb(255, 255, 255); background-color: rgb(230, 0, 18); font-size: 9pt; border: 1px solid rgb(230, 0, 18); border-radius: 10px; margin: 0px 0.5rem; padding: 7px 2px;"
                      @click="onGo(content)"
                    >
                      この企業で応募
                    </div>
                    <div
                      v-else
                      class="bg-top bg-no-repeat bg-cover bg-fixed w-full select-none content-button"
                      style="color: rgb(255, 255, 255); background-color: rgb(161, 161, 161); font-size: 9pt; border: 1px solid rgb(161, 161, 161); border-radius: 10px; margin: 0px 0.5rem; padding: 7px 2px;"
                    >
                      応募期間外
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import dayjs from 'dayjs';
import { defineComponent } from 'vue';

import { useRouting } from '@/hooks/use_routing';
import { useState } from '@/hooks/use_state';
import { Common } from '@/models/common';
import { TieUp } from '@/models/tie_up';
import RouterConst from '@/router/router_const';

export default defineComponent({
  name: 'ContentStoreSelect',
  setup() {
    const state = useState();
    const routing = useRouting();
    const parsedData = JSON.parse(state.value.common);
    const common = new Common(parsedData);
    const akasatanas = ['あ行', 'か行', 'さ行', 'た行', 'な行', 'は行', 'ま行', 'や行', 'ら行', 'わ行'];

    const onGo = (content:TieUp) => {
      state.value.id = content.id || '';
      state.value.store = content.store || '';
      state.value.shipping = content.shipping || '';
      state.value.begin = content.begin || '';
      state.value.end = content.end || '';
      routing.redirect(RouterConst.TieUpStore);
    };

    return {
      akasatanas,
      dayjs,
      onGo,
      common,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
